import $api from "../../axios"
import { AppDispatch } from "../index"
import { medicalSlice } from "../slices/medicalSlice"
import { IFetchMedicalInstitutionsParams, IMedicalInstitution, IMedicalInstitutionPayload } from "../../models/medical"

export const fetchMedicalInstitutions = (params: IFetchMedicalInstitutionsParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(medicalSlice.actions.fetching());
    const response = await $api.get<IMedicalInstitutionPayload>("medical/medical-institution/index", {
      params
    });
    dispatch(medicalSlice.actions.fetchSuccess(response.data));
    return response.data.list;
  } catch (e: any) {
    dispatch(medicalSlice.actions.fetchError(e));
    return [];
  }
}
export const addMedicalInstitution = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(medicalSlice.actions.adding())
    const response = await $api.post<IMedicalInstitution>("/medical/medical-institution/add", data)
    dispatch(medicalSlice.actions.addSuccess(response.data))
    return response.data.id
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(medicalSlice.actions.addError(e.response.data))
    }
  }
}

export const updateMedicalInstitution = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(medicalSlice.actions.updating())
    await $api.put<IMedicalInstitution>("/medical/medical-institution/edit", data)
    dispatch(medicalSlice.actions.updateSuccess())
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(medicalSlice.actions.addError(e.response.data))
    }
  }
}

export const deleteMedicalInstitution = (medical_uuid: string) => async (dispatch: AppDispatch) => {
  try {
    await $api.delete("/medical/medical-institution/delete", {
      params: {
        medical_uuid
      }
    })
    return true
  } catch (e: any) {
    console.log(e)
  }
}

export const getMedicalInstitution = (medical_uuid: string) => async (dispatch: AppDispatch) => {
  try {
    return await $api.get("medical/medical-institution/get", {
      params: {
        medical_uuid
      }
    })
  } catch (e: any) {
    console.log(e)
  }
}

export const setCurrentPage = (pageNumber: number) => (dispatch: AppDispatch) => {
  dispatch(medicalSlice.actions.setCurrentPage(pageNumber))
}